import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

type CheckboxProps = {
  checked: boolean;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  "aria-label"?: string;
  title?: string;
};

export function Checkbox({
  checked,
  disabled,
  onCheckedChange,
  "aria-label": ariaLabel,
  title,
}: CheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
      onClick={() => onCheckedChange?.(!checked)}
      className={cn(
        "inline-flex size-4 items-center justify-center rounded-sm border",
        checked
          ? "border-gray-900 bg-gray-900 text-white dark:border-white dark:bg-white dark:text-gray-900"
          : "border-gray-300 bg-white dark:border-white/30 dark:bg-transparent",
        disabled && "cursor-not-allowed opacity-50",
      )}
    >
      {checked ? <Check className="size-3" aria-hidden /> : null}
    </button>
  );
}
